var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MemberProfileEdit/MemberProfileEditDomicile.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MemberProfileEdit/MemberProfileEditDomicile.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data", "dictionaries"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("dictionaries", Object.prototype.hasOwnProperty.call(kwargs, "dictionaries") ? kwargs["dictionaries"] : {});var t_5 = "";t_5 += "\n    <div class=\"MemberProfileEditDomicile\">\n        <div class=\"MemberProfileEditDomicile-body MemberProfileEdit-scrollbox\">\n            <form class=\"MemberProfileEditDomicile-body-form\">\n                <div class=\"MemberProfileEditDomicile-body-inputsBlock MemberProfileEditDomicile-body-inputsBlockCountry\">\n                    <div class=\"MemberProfileEditDomicile-body-inputs-inputName\">\n                        Country\n                    </div>\n                    <div class=\"MemberProfileEditDomicile-body-inputs-inputWrapper\">\n                        <select name=\"domicile_country\" class=\"MemberProfileEditDomicile-body-inputs-input MemberProfileEditDomicile-body-inputs-input--select\">\n                            <option ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") || !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"country")) {
t_5 += "selected";
;
}
t_5 += " value=\"0\">NONE</option>\n                            ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dictionaries")),"countries");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_6;
if(runtime.isArray(t_8)) {
var t_7 = t_8.length;
for(t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6][0];
frame.set("[object Object]", t_8[t_6][0]);
var t_10 = t_8[t_6][1];
frame.set("[object Object]", t_8[t_6][1]);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                                <option value=\"";
t_5 += runtime.suppressValue(t_9, env.opts.autoescape);
t_5 += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"country") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"country") == t_9) {
t_5 += "selected";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(t_10, env.opts.autoescape);
t_5 += "</option>\n                            ";
;
}
} else {
t_6 = -1;
var t_7 = runtime.keys(t_8).length;
for(var t_11 in t_8) {
t_6++;
var t_12 = t_8[t_11];
frame.set("key", t_11);
frame.set("value", t_12);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                                <option value=\"";
t_5 += runtime.suppressValue(t_11, env.opts.autoescape);
t_5 += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"country") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"country") == t_11) {
t_5 += "selected";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(t_12, env.opts.autoescape);
t_5 += "</option>\n                            ";
;
}
}
}
frame = frame.pop();
t_5 += "\n                        </select>\n                    </div>\n                </div>\n\n                <div class=\"MemberProfileEditDomicile-body-inputsBlock MemberProfileEditDomicile-body-inputsBlockState\">\n                    <div class=\"MemberProfileEditDomicile-body-inputs-inputName\">\n                        State\n                    </div>\n                    <div class=\"MemberProfileEditDomicile-body-inputs-inputWrapper\">\n                        <select name=\"domicile_state\" class=\"MemberProfileEditDomicile-body-inputs-input MemberProfileEditDomicile-body-inputs-input--select\">\n                            <option ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") || !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"state")) {
t_5 += "selected";
;
}
t_5 += " value=\"0\">NONE</option>\n                            ";
frame = frame.push();
var t_15 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "dictionaries")),"states");
if(t_15) {t_15 = runtime.fromIterator(t_15);
var t_13;
if(runtime.isArray(t_15)) {
var t_14 = t_15.length;
for(t_13=0; t_13 < t_15.length; t_13++) {
var t_16 = t_15[t_13][0];
frame.set("[object Object]", t_15[t_13][0]);
var t_17 = t_15[t_13][1];
frame.set("[object Object]", t_15[t_13][1]);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
t_5 += "\n                                <option value=\"";
t_5 += runtime.suppressValue(t_16, env.opts.autoescape);
t_5 += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"state") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"state") == t_16) {
t_5 += "selected";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(t_17, env.opts.autoescape);
t_5 += "</option>\n                            ";
;
}
} else {
t_13 = -1;
var t_14 = runtime.keys(t_15).length;
for(var t_18 in t_15) {
t_13++;
var t_19 = t_15[t_18];
frame.set("key", t_18);
frame.set("value", t_19);
frame.set("loop.index", t_13 + 1);
frame.set("loop.index0", t_13);
frame.set("loop.revindex", t_14 - t_13);
frame.set("loop.revindex0", t_14 - t_13 - 1);
frame.set("loop.first", t_13 === 0);
frame.set("loop.last", t_13 === t_14 - 1);
frame.set("loop.length", t_14);
t_5 += "\n                                <option value=\"";
t_5 += runtime.suppressValue(t_18, env.opts.autoescape);
t_5 += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"state") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"domicile")),"state") == t_18) {
t_5 += "selected";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(t_19, env.opts.autoescape);
t_5 += "</option>\n                            ";
;
}
}
}
frame = frame.pop();
t_5 += "\n                        </select>\n                    </div>\n                </div>\n            </form>\n        </div>\n        <div class=\"MemberProfileEditDomicile-buttons\">\n            <div class=\"MemberProfileEditDomicile-buttons-button MemberProfileEditDomicile-buttons-button--cancel\">\n                cancel\n            </div>\n            <div class=\"MemberProfileEditDomicile-buttons-button MemberProfileEditDomicile-buttons-button--save\">\n                save\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("MemberProfileEditDomicile");
context.setVariable("MemberProfileEditDomicile", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MemberProfileEdit/MemberProfileEditDomicile.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditDomicile.jinja
// module id = 114
// module chunks = 0